import {Link, LinkContentWrapper, SideNav, UserMenu,} from "@cjdev-internal/visual-stack-redux/lib/components/SideNav";
import CJLogo from "@cjdev-internal/visual-stack/lib/components/CJLogo";
import HomeIcon from "mdi-react/HomeIcon";
import {APP_NAME, INDEX_MENU_LABEL, INDEX_PAGE_HOVER, LOGOUT_LABEL} from "../../constants/appConstant";
import {logout} from "@platform/platform-auth";


export const UserMenuData = ({userProfileData}) => {
    const fullName = (userProfileData.firstName === undefined && userProfileData.lastName === undefined) ? "" : userProfileData.firstName + " " + userProfileData.lastName;
    return (

        <UserMenu
            onLogout={() => {
                logout();
            }}

            label={fullName}
            logoutLabel={LOGOUT_LABEL}
            firstInitial={
                userProfileData.lastName ? userProfileData.firstName[0] : ""
            }
            lastInitial={userProfileData.lastName ? userProfileData.lastName[0] : ""}
        >
        </UserMenu>
    );
}

export const SideNavComponent = ({userMenu}) => {
    return (
        <SideNav
            userMenu={userMenu}
            logoBackground="#00AF66"
            logo={<CJLogo/>}
            appName={APP_NAME}
        >
            <Link hoverText={INDEX_PAGE_HOVER}>
                <a href="/">
                    <LinkContentWrapper icon={<HomeIcon/>} label={INDEX_MENU_LABEL}/>
                </a>
            </Link>
        </SideNav>
    );
}
